import React from 'react';
import { MapPinIcon, PhoneIcon, ShieldIcon } from 'lucide-react';
export function Header() {
  return <header className="relative bg-black overflow-hidden border-b border-zinc-800 pt-16 pb-20 md:pt-20 md:pb-24" data-id="element-216">
      <div className="absolute inset-0 z-0" data-id="element-217">
        <div className="absolute inset-0 bg-gradient-to-r from-black to-zinc-900 opacity-90" data-id="element-218"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1582139329536-e7284fece509?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-5" data-id="element-219"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" data-id="element-220"></div>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-221">
        <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-16" data-id="element-222">
          <div className="w-44 h-44 md:w-60 md:h-60 rounded-full overflow-hidden border-2 border-zinc-700 shadow-lg flex-shrink-0 bg-zinc-900" data-id="element-223">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ua2DbajtjLfXUiariEe66y/Ahmet_Uzun_Pasfoto_.jpg" alt="Ahmet Uzun" className="w-full h-full object-cover grayscale" data-id="element-224" />
          </div>
          <div className="text-center md:text-left" data-id="element-225">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light tracking-tight mb-3" data-id="element-226">
              Ahmet Uzun
            </h1>
            <p className="mt-2 text-lg md:text-xl text-slate-400 font-normal" data-id="element-227">
              Professioneel Beveiliger
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center md:justify-start gap-5 sm:gap-8 text-sm" data-id="element-228">
              <div className="flex items-center gap-2" data-id="element-229">
                <MapPinIcon className="w-4 h-4 text-zinc-500" data-id="element-230" />
                <span data-id="element-231">Assendelft, Nederland</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-232">
                <PhoneIcon className="w-4 h-4 text-zinc-500" data-id="element-233" />
                <span data-id="element-234">06 55987275</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-235">
                <ShieldIcon className="w-4 h-4 text-zinc-500" data-id="element-236" />
                <span data-id="element-237">Saense Beveiliging</span>
              </div>
            </div>
            <div className="mt-8 flex flex-wrap justify-center md:justify-start gap-4" data-id="element-238">
              <a href="https://www.kilicsecurityservices.nl/wp-content/uploads/2025/08/CV_Ahmet_Uzun.pdf" target="_blank" rel="noopener noreferrer" className="px-5 py-2.5 bg-zinc-900 hover:bg-zinc-800 text-white text-sm font-normal rounded-none border border-zinc-800 transition-colors" data-id="element-239">
                Download CV
              </a>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-240">
              <a href="#contact-new" className="px-6 py-3 bg-slate-800 hover:bg-slate-900 text-white font-normal text-sm rounded-none transition-colors text-center" data-id="element-241">
                Beveiligingsdienst inhuren
              </a>
              <a href="#contact-new" className="px-6 py-3 border border-zinc-700 hover:border-zinc-600 text-gray-200 font-normal text-sm rounded-none transition-colors text-center" data-id="element-242">
                Offerte aanvragen
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>;
}